export const data = [
  {
    projectName: "Digistorepay",
    projectType: "Company Project",
    companylogo: require("../assets/images/logos/digistorepay.png"),
    projectImage: require("../assets/images/screens/digistorepay_screen.png"),
    description:
      "Digistorepay is a payments aggregator platform that streamline your business transactions with our secure and user-friendly payment solutions and services.",
    status: "Online",
    tech: ["React JS", "PostgreSQL", "Node JS", "Azure"],
    details: [
      {
        id: 8,
        duration: "1 Year",
        role: "Team Lead (PERN)",
      },
    ],
    link: "https://www.digistorepay.com/",
  },
  {
    projectName: "Skillojo",
    projectType: "Freelance Client",
    companylogo: require("../assets/images/logos/skillojo.webp"),
    projectImage: require("../assets/images/screens/skillojo_screen.png"),
    description:
      "Skillojo is an AI-enabled Job Description Builder Platform that help organizations and candidates make faster-recruiting decisions.You can now hire for attitude and train for skills with Skillojo’s AI-powered talent acquisition platform.",
    status: "Online",
    tech: ["Next.JS", "SCSS", "Redux"],
    details: [
      {
        id: 7,
        duration: "6 Months",
        role: "Full Stack Developer",
      },
    ],
    link: "https://www.skillojo.com/",
  },
  {
    projectName: "MasterFraming",
    projectType: "Freelance Client",
    companylogo: require("../assets/images/logos/masterframing.jpg"),
    projectImage: require("../assets/images/screens/masterframing_screen.png"),
    description:
      "MasterFraming can arrange all your framing and related services under one roof. Furthermore, Master Framing offers pickup and delivery in the Sydney region and courier delivery across the nation.",
    status: "Online",
    tech: ["Next.JS", "Postman", "Lighthouse"],
    details: [
      {
        id: 6,
        duration: "2 Months",
        role: "Improve Site Performance",
      },
    ],
    link: "https://masterframing.com.au/",
  },
  {
    projectName: "DigiPay",
    projectType: "Company Project",
    companylogo: require("../assets/images/logos/digipay.png"),
    projectImage: require("../assets/images/screens/digipay_screen.png"),
    description:
      "DigiPay is a wallet payment service platform for Digisuvidha customers",
    status: "Online - Internal Use",
    tech: ["Angular", "ProsgresQL"],
    details: [
      {
        id: 5,
        duration: "5 Months",
        role: "Full Stack Developer",
      },
    ],
  },
  {
    projectName: "DigiSuvidha",
    projectType: "Company Project",
    companylogo: require("../assets/images/logos/digisuvidha.png"),
    projectImage: require("../assets/images/screens/digisuvidha_screen.png"),
    description:
      "DigiSuvidha is a service aggregator platform for retail businesses, with over 750+ franchises",
    status: "Offline - Site Revamped as business model changed",
    tech: ["React", "Bootstrap"],
    details: [
      {
        id: 4,
        duration: "2 Months",
        role: "React Developer",
      },
    ],
    link: "https://digisuvidha.netlify.app/",
    github:'https://github.com/Jobin235/digisuviapp',
  },
  {
    projectName: "Dephyn",
    projectType: "Company Project",
    companylogo: require("../assets/images/logos/phyction.png"),
    projectImage: require("../assets/images/screens/dephyn_screen.png"),
    description:
      "Dephyn is a project management and report generation tool used internally at Phyction Ai Labs",
    status: "Online - Internal Use",
    tech: ["React", "Stripe", "Node"],
    details: [
      {
        id: 3,
        duration: "6 Months",
        role: "Full Stack Developer",
      },
    ],
  },
  {
    projectName: "Appointy",
    projectType: "Company Project",
    companylogo: require("../assets/images/logos/appointy.png"),
    projectImage: require("../assets/images/screens/appointy_screen.png"),
    description:
      "Appointy is an online appointment booking  platform. Save time spent on coordinating appointments over phone and email with an all-in-one appointment booking software",
    status: "Online",
    tech: ["React", "Moment.JS"],
    details: [
      {
        id: 2,
        duration: "3 Months",
        role: "React Developer",
      },
    ],
    link: "https://www.appointy.com/online-booking-software/?itm_source=appointy_homepage&itm_medium=btn_knowmore&itm_campaign=homepage_visitors&itm_term=default&itm_content=default",
  },
  {
    projectName: "Medclick",
    projectType: "Freelance Client",
    companylogo: require("../assets/images/logos/medclick.jpeg"),
    projectImage: require("../assets/images/screens/medclick_screen.png"),
    description:
      "Medclick.com(TM) is the first digital health management software platform that combines the benefits of artificial intelligence, blockchain technology and humanintelligence to deliver outstanding healthcare services",
    status: "Offline - Site Revamped as business model changed",
    tech: ["Angular", "EmailJs", "Bing Maps"],
    details: [
      {
        id: 1,
        duration: "4 Months",
        role: "Angular Developer",
      },
    ],
    link: "https://medclick.netlify.app",
    github:'https://github.com/Jobin235/medclick',
  },
];
